
import { mapGetters, mapActions } from 'vuex';
export default {
    components: {
    },
    data() {
        return {
            animated_images: {
                src     : '/images/animated-secuence/home-banner/banner-animated-secuence-01_420.webp',
                sizes   : '(max-width: 480px) 213px, (max-width: 768px) 280px, (min-width: 769px) 420px',
                srcset  : [
                '/images/animated-secuence/home-banner/banner-animated-secuence-01_213.webp 213w',
                '/images/animated-secuence/home-banner/banner-animated-secuence-01_280.webp 280w',
                '/images/animated-secuence/home-banner/banner-animated-secuence-01_420.webp 420w',
                '/images/animated-secuence/home-banner/banner-animated-secuence-01_560.webp 560w',
                ],
                loading : 'eager',
                alt : 'Wholesale shapewear distributor portal offering top Colombian brands for U.S. resellers'
            },
            animated_alts: [
                'Wholesale shapewear distributor portal offering top Colombian brands for U.S. resellers',
                'Shapewear distributors’ trusted source for premium Colombian girdles and waist cinchers',
                'Wholesale girdles and compression wear for body contouring and post-surgical recovery',
                'Order wholesale waist cinchers online from a leading B2B shapewear portal',
                'Top-rated wholesale body shapers for fashion retailers and distributor networks',
                'Shapewear wholesale solutions for U.S.-based retailers and ecommerce businesses',
                'Distributor shapewear options from Colombia’s top wholesale shapewear supplier',
                'Wholesale compression garments for retailers seeking premium quality and fast shipping',
                'B2B shapewear solutions with bulk ordering and streamlined distributor registration',
                'Wholesale body shapers portal with exclusive deals for first-time buyers',
                'Shapewear suppliers offering the latest body contouring technology for wholesale clients',
                'Buy wholesale body shapers and compression wear with secure B2B portal checkout',
                'Wholesale fashion shapewear for boutiques and ecommerce shapewear distributors',
                'Bulk order wholesale waist trainers through our trusted shapewear portal',
                'Best B2B wholesale shapewear platform for Colombian brands and fast U.S. delivery',
                'Leading wholesale portal for high-quality shapewear, girdles, and compression garments'
            ]
        }
    },
    async mounted() {
        
        let change_image = 2;
        setTimeout(() => {
            
            setInterval(() => {
                this.animated_images.src        = `/images/animated-secuence/home-banner/banner-animated-secuence-${ change_image <= 9 ? `0${ change_image }` : change_image }_420.webp`;
                this.animated_images.srcset     = [
                `/images/animated-secuence/home-banner/banner-animated-secuence-${ change_image <= 9 ? `0${ change_image }` : change_image }_213.webp 213w`,
                `/images/animated-secuence/home-banner/banner-animated-secuence-${ change_image <= 9 ? `0${ change_image }` : change_image }_280.webp 280w`,
                `/images/animated-secuence/home-banner/banner-animated-secuence-${ change_image <= 9 ? `0${ change_image }` : change_image }_420.webp 420w`,
                `/images/animated-secuence/home-banner/banner-animated-secuence-${ change_image <= 9 ? `0${ change_image }` : change_image }_560.webp 560w`
                ];
                this.animated_images.alt        = this.animated_alts[ change_image - 1 ];
                change_image++;
                if( change_image == 18 ) {
                    
                    change_image = 1;
                }
            }, 200);
        }, 6000);
    },
    computed: {
        ...mapGetters({
        }),
        getAnimatedImage(){
            
            return this.animated_images;
        }
    },
    methods: {
        ...mapActions({
        })
    }
}
